import React, { useContext, useEffect } from 'react';
import { MapContext } from 'react-mapbox-gl';
import styled from 'styled-components';
import { i18n } from '@lt/localization';
import { CollapseArrows, ExpandArrows } from '@lt/components/icons-react/map';

import { pushMapExpanded } from '../../analitics';

interface ExpandControlProps {
  isExpanded: boolean;
  toggleHandler: () => void;
  expandText?: string;
  collapseText?: string;
  position?: 'top' | 'bottom';
}

/**
 * Контролл позволяет свернуть/развернуть карту
 */
export const ExpandControl = (props: ExpandControlProps): JSX.Element => {
  const {
    isExpanded,
    expandText = i18n.t('map.controls.expand'),
    collapseText = i18n.t('map.controls.collapse'),
    position = 'top',
    toggleHandler,
  } = props;

  const map = useContext(MapContext);

  /**
   * Изменить размер карты, если произошло скрытие/раскрытие
   */
  useEffect(() => {
    map?.resize();
  }, [map, isExpanded]);

  const handleClick = () => {
    toggleHandler();

    pushMapExpanded(isExpanded);
  };

  return (
    <Container $position={position}>
      <Button onClick={handleClick}>
        <Icon as={isExpanded ? CollapseArrows : ExpandArrows} />
        {isExpanded ? collapseText : expandText}
      </Button>
    </Container>
  );
};

const Icon = styled.div`
  width: 16px;
  width: 15px;
  margin-right: 5px;
`;

const Button = styled.button`
  padding: 0 10px;
  display: flex;
  min-width: 170px;
  height: 37px;
  justify-content: center;
  align-items: center;
  opacity: 0.95;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #171719;
  background-color: #f9f9f9;
  border-width: 0 0 1px;
  border-left-style: initial;
  border-right-style: initial;
  border-bottom-color: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  outline: 0;
  transition: background-color 0.16s ease-out;
  cursor: pointer;

  &:hover {
    opacity: 1;
    background-color: rgb(255, 255, 255);
  }
`;

const Container = styled.div<{ $position: string }>`
  position: absolute;
  z-index: 20;
  right: 10px;
  height: 37px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px;

  ${({ $position }) =>
    $position &&
    `
      ${$position}: 10px;
    `}
`;
